import { render } from "./MSpeechBubble.vue?vue&type=template&id=8887663e&scoped=true&ts=true"
import script from "./MSpeechBubble.vue?vue&type=script&lang=ts"
export * from "./MSpeechBubble.vue?vue&type=script&lang=ts"

import "./MSpeechBubble.vue?vue&type=style&index=0&id=8887663e&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8887663e"]])

export default __exports__